export default "__VITE_ASSET__9h4FbLgU__"